(() => {
  const ROOT_URL = window.Shopify?.routes?.root || "/";

  function showToast(message) {
    const existingToast = document.querySelector(".tot-toast");

    if (existingToast) {
      existingToast.remove();
    }

    const toast = document.createElement("div");
    toast.className = "tot-toast";
    toast.setAttribute("role", "status");
    toast.textContent = message;

    document.body.appendChild(toast);

    window.setTimeout(() => {
      toast.remove();
    }, 2500);
  }

  function setButtonLoading(button, loading) {
    const label = button.querySelector("[data-tot-button-label]");
    const loader = button.querySelector("[data-tot-button-loader]");

    button.disabled = loading;

    if (label) {
      label.hidden = loading;
    }

    if (loader) {
      loader.hidden = !loading;
    }
  }

  function getCartSectionId() {
    const cartItems = document.querySelector(
      "cart-drawer-component cart-items-component[data-section-id]"
    );

    return cartItems?.dataset?.sectionId || "";
  }

  async function fetchUpdatedCartDrawer() {
    const sectionId = getCartSectionId();

    if (!sectionId) {
      return false;
    }

    const url = new URL(window.location.href);
    url.searchParams.set("sections", sectionId);

    const response = await fetch(url.toString(), {
      method: "GET",
      headers: {
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    });

    if (!response.ok) {
      return false;
    }

    const sections = await response.json();
    const sectionHTML = sections?.[sectionId];

    if (!sectionHTML) {
      return false;
    }

    const parser = new DOMParser();
    const parsedDocument = parser.parseFromString(sectionHTML, "text/html");

    const newDrawer = parsedDocument.querySelector("cart-drawer-component");
    const currentDrawer = document.querySelector("cart-drawer-component");

    if (!newDrawer || !currentDrawer) {
      return false;
    }

    const wasOpen = Boolean(
      currentDrawer.querySelector("dialog[open]")
    );

    currentDrawer.replaceWith(newDrawer);

    if (wasOpen) {
      window.requestAnimationFrame(() => {
        const refreshedDrawer = document.querySelector(
          "cart-drawer-component"
        );

        const refreshedDialog = refreshedDrawer?.querySelector("dialog");

        if (refreshedDialog && !refreshedDialog.open) {
          try {
            refreshedDialog.showModal();
          } catch (error) {
            refreshedDialog.setAttribute("open", "");
          }
        }
      });
    }

    return true;
  }

  function dispatchCartEvents(cart) {
    document.dispatchEvent(
      new CustomEvent("cart:update", {
        bubbles: true,
        detail: {
          cart,
          source: "tot-cart-recommendation",
          itemCount: cart?.item_count,
        },
      })
    );

    document.dispatchEvent(
      new CustomEvent("cart:refresh", {
        bubbles: true,
        detail: {
          cart,
          source: "tot-cart-recommendation",
        },
      })
    );
  }

  async function getCurrentCart() {
    const response = await fetch(`${ROOT_URL}cart.js`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    });

    if (!response.ok) {
      throw new Error("The cart could not be refreshed.");
    }

    return response.json();
  }

  async function addRecommendedProduct(button) {
    const variantId = Number(button.dataset.variantId);

    if (!variantId || button.disabled) {
      return;
    }

    setButtonLoading(button, true);

    try {
      const response = await fetch(`${ROOT_URL}cart/add.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1,
            },
          ],
        }),
      });

      const result = await response.json().catch(() => ({}));

      if (!response.ok) {
        throw new Error(
          result.description ||
            result.message ||
            "This product could not be added."
        );
      }

      const cart = await getCurrentCart();

      dispatchCartEvents(cart);

      const refreshed = await fetchUpdatedCartDrawer();

      if (!refreshed) {
        showToast("Added to your bag.");

        window.setTimeout(() => {
          window.location.reload();
        }, 500);

        return;
      }

      showToast("Added to your bag.");
    } catch (error) {
      console.error("TOT cart recommendation error:", error);

      setButtonLoading(button, false);

      const label = button.querySelector("[data-tot-button-label]");

      if (label) {
        label.textContent = "Try again";
        label.hidden = false;
      }

      showToast(
        error.message ||
          "The product could not be added. Please try again."
      );
    }
  }

  function toggleOffers(button) {
    const cartExtras = button.closest("[data-tot-cart-extras]");
    const content = cartExtras?.querySelector("[data-tot-offers-content]");

    if (!content) {
      return;
    }

    const currentlyExpanded =
      button.getAttribute("aria-expanded") === "true";

    button.setAttribute(
      "aria-expanded",
      currentlyExpanded ? "false" : "true"
    );

    content.hidden = currentlyExpanded;
  }

  document.addEventListener("click", (event) => {
    const addButton = event.target.closest("[data-tot-add]");

    if (addButton) {
      event.preventDefault();
      addRecommendedProduct(addButton);
      return;
    }

    const offersToggle = event.target.closest("[data-tot-offers-toggle]");

    if (offersToggle) {
      event.preventDefault();
      toggleOffers(offersToggle);
    }
  });
})();